Apt.fn.extend('index', {
	/**
	 * Submit controls
	 */
	submit() {
		$(this.conf.controls).trigger('submit');
	}
}, {
	/**
	 * Initialize application controls
	 *
	 * @param {Object} conf
	 */
	initControls(conf) {
		if (! conf.controls) {
			return;
		}

		const pub = this.$public;
		const $form = $(conf.controls);

		if (conf.validate) {
			$form[0].noValidate = true;
		}

		$form.on('submit', () => {
			if (conf.validate && ! LS.form.validate($form)) {
				return;
			}

			const filters = $form.serialize(true);

			filters.page = 1;

			pub.filter(filters);
		}, {
			cancel: true,
			namespace: pub.uid
		});
	}
});